export const parseOwnerIds = (rawOwnerIds?: string | null): string[] => {
  if (!rawOwnerIds) return [];
  return rawOwnerIds
    .split(',')
    .map((ownerIdValue) => ownerIdValue.trim())
    .filter((ownerIdValue) => ownerIdValue.length > 0);
};
